import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    tabPersonalInfo: "Προσωπικά στοιχεία",
    tabOrderHistory: "Ιστορικό παραγγελιών",
    tabTransactionHistory: "Ιστορικό κινήσεων",
    myInfoHeading: "ΤΑ ΣΤΟΙΧΕΙΑ ΜΟΥ",
    personalInfoHeading: "ΣΤΟΙΧΕΙΑ ΓΟΝΕΑ",
    firstName: "Όνομα",
    lastName: "Επώνυμο",
    email: "Email",
    verified: "Επαληθευμένο",
    emailSpamHint:
        "Αν δεν λάβεις το email, έλεγξε το φάκελο spam σου.",
    mobile: "Τηλέφωνο",
    profileFieldEmpty: "Δεν έχει συμπληρωθεί",
    mobileInputPlaceholder: "π.χ. +30 691 234 5678",
    verificationEmailSentBanner:
        "Το email επαλήθευσης στάλθηκε επιτυχώς! Έλεγξε τα εισερχόμενά σου και κάνε κλικ στον σύνδεσμο επαλήθευσης.",
    emailVerifiedSuccessBanner: "Το email επαληθεύθηκε επιτυχώς!",
    emailNotVerifiedAfterCheckBanner:
        "Το email δεν έχει ακόμα επαληθευθεί. Έλεγξε τα εισερχόμενά σου και κάνε κλικ στον σύνδεσμο επαλήθευσης.",
    sendVerificationEmailError:
        "Αποτυχία αποστολής email επαλήθευσης. Δοκίμασε ξανά.",
    verificationAuthTooManyRequests:
        "Πάρα πολλές προσπάθειες. Δοκίμασε ξανά αργότερα.",
    verificationAuthNetworkError:
        "Πρόβλημα σύνδεσης. Έλεγξε το δίκτυό σου και δοκίμασε ξανά.",
    checkVerificationStatusError:
        "Αποτυχία ελέγχου κατάστασης επαλήθευσης. Δοκίμασε ξανά.",
    verificationEmailButton: "Email επαλήθευσης",
    verificationEmailRetryIn: (seconds: number) => `Μπορείς να ξαναστείλεις σε ${seconds} δευτ.`,
    verifyButton: "Επαλήθευση",
    pleaseEnterEmail: "Συμπλήρωσε ένα email",
    pleaseEnterValidEmail: "Συμπλήρωσε ένα έγκυρο email",
    emailMustBeDifferent: "Το νέο email πρέπει να είναι διαφορετικό από το τρέχον",
    errorUpdatingEmail: "Σφάλμα κατά την ενημέρωση του email",
    emailAlreadyInUse: "Αυτό το email χρησιμοποιείται ήδη από άλλο λογαριασμό",
    invalidEmail: "Μη έγκυρο email",
    pleaseLoginAgain: "Συνδέσου ξανά",
    noPermission: "Δεν έχεις δικαιώματα για αυτή την ενέργεια",
    emailUpdatedSuccessfully:
        "Το email ενημερώθηκε επιτυχώς! Θα αποσυνδεθείς τώρα για να συνδεθείς ξανά με το νέο email.",
    updating: "Ενημέρωση...",
    update: "Ενημέρωση",
    newEmailLabel: "Νέο Email",
    editEmailTitle: "Επεξεργασία Email",
    editFieldAria: (fieldLabel: string) => `Επεξεργασία ${fieldLabel}`,
    currentEmailPrefix: "Τρέχον email:",
    selectRolePlaceholder: "Επίλεξε ρόλο",
    selectClassroomPlaceholder: "Επίλεξε τάξη",
    deleteStudentErrorDlgTitleStudent: "Αδυναμία διαγραφής μαθητή",
    deleteStudentErrorDlgTitleStaff: "Αδυναμία διαγραφής προσωπικού",
    deleteStudentErrorDlgMsg:
        "Υπάρχουν ενεργές παραγγελίες ή παραγγελίες που πραγματοποιήθηκαν τον τελευταίο μήνα. Μπορείς να πραγματοποιήσεις μόνο αλλαγές.",
    newStudentPlaceholder: "Νέος μαθητής",
    newStaffPlaceholder: "Νέο προσωπικό",
    studentInfoHeading: "ΣΤΟΙΧΕΙΑ ΜΑΘΗΤΗ",
    staffInfoHeading: "ΣΤΟΙΧΕΙΑ ΠΡΟΣΩΠΙΚΟΥ",
    personnelSectionHeading: "ΣΤΟΙΧΕΙΑ ΠΡΟΣΩΠΙΚΟΥ",
    personnelCheckboxLabel:
        "Εργάζομαι στο σχολείο και θέλω να παραγγείλω γεύματα μέσω της πλατφόρμας",
    studentsSectionHeading: "ΣΤΟΙΧΕΙΑ ΜΑΘΗΤΩΝ",
    addStudentLink: "Προσθήκη μαθητή",
    staffRoleErrorMsg: "Επίλεξε τον ρόλο σου στο σχολείο",
    studentNameLabel: "Όνομα μαθητή",
    staffNameLabel: "Όνομα προσωπικού",
    studentLastNameLabel: "Επώνυμο μαθητή",
    staffLastNameLabel: "Επώνυμο προσωπικού",
    studentClassroomLabel: "Τμήμα μαθητή",
    roleInSchoolLabel: "Ρόλος στο σχολείο:",
    allergiesSectionHeading: "Αλλεργίες και άλλες διατροφικές ιδιαιτερότητες",
    allergiesIconAria: "Αλλεργίες",
    editPersonRowAria: "Επεξεργασία",
    deletePersonRowAria: (displayName: string) => `Διαγραφή ${displayName}`,
    removePersonnelFromOrderingConfirmTitle: "Θέλεις να αφαιρεθείς από το προσωπικό του σχολείου;",
    removePersonnelFromOrderingConfirmMsg: "Δεν θα μπορείς να παραγγέλνεις γεύματα ως εργαζόμενος μέσω της πλατφόρμας.",
    removePersonnelFromOrderingConfirmYes: "Αφαίρεση",
    intolerancesFreeTextLabel: "Άλλες διατροφικές ιδιαιτερότητες",
    intolerancesFreeTextPlaceholder:
        "Διατροφικές ιδιαιτερότητες που ΔΕΝ περιγράφονται από πάνω",
    phoneVerifiedBadge: "Το τηλέφωνο έχει επαληθευτεί",
    phoneVerificationHeading: "Επαλήθευση τηλεφώνου",
    phoneSendCode: "Αποστολή Κωδικού",
    phoneEnterCodePrompt: "Εισήγαγε τον κωδικό που έλαβες:",
    phoneConfirm: "Επιβεβαίωση",
    /** Short label for changing verified phone (not generic “Τροποποίηση”). */
    phoneChangeShort: "Αλλαγή",
    phoneVerificationNotStarted: "Η διαδικασία επαλήθευσης δεν ξεκίνησε.",
    phoneRecaptchaExpired: "Το reCAPTCHA έληξε. Δοκίμασε ξανά.",
    phoneRecaptchaRenderFailed: "Αποτυχία εμφάνισης reCAPTCHA. Ανένεωσε τη σελίδα.",
    phoneRecaptchaNotReady: "Το reCAPTCHA δεν είναι έτοιμο. Περίμενε λίγο.",
};

const en: typeof el = {
    tabPersonalInfo: "Personal info",
    tabOrderHistory: "Order history",
    tabTransactionHistory: "Transaction history",
    myInfoHeading: "My Info",
    personalInfoHeading: "Parent Info",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    verified: "Verified",
    emailSpamHint: "If you don't receive the email, check your spam folder.",
    mobile: "Mobile",
    profileFieldEmpty: "Not filled in",
    mobileInputPlaceholder: "e.g. +30 691 234 5678",
    verificationEmailSentBanner:
        "Verification email sent successfully! Please check your inbox and click the verification link.",
    emailVerifiedSuccessBanner: "Email verified successfully!",
    emailNotVerifiedAfterCheckBanner:
        "Email not yet verified. Please check your inbox and click the verification link.",
    sendVerificationEmailError:
        "Failed to send verification email. Please try again.",
    verificationAuthTooManyRequests:
        "Too many attempts. Please try again later.",
    verificationAuthNetworkError:
        "Connection problem. Check your network and try again.",
    checkVerificationStatusError:
        "Failed to check verification status. Please try again.",
    verificationEmailButton: "Verification email",
    verificationEmailRetryIn: (seconds: number) => `You can try again in ${seconds}s`,
    verifyButton: "Verify",
    pleaseEnterEmail: "Please enter an email",
    pleaseEnterValidEmail: "Please enter a valid email",
    emailMustBeDifferent: "New email must be different from current email",
    errorUpdatingEmail: "Error updating email",
    emailAlreadyInUse: "This email is already in use by another account",
    invalidEmail: "Invalid email",
    pleaseLoginAgain: "Please log in again",
    noPermission: "You do not have permission for this action",
    emailUpdatedSuccessfully:
        "Email updated successfully! You will now be logged out to sign in again with the new email.",
    updating: "Updating...",
    update: "Update",
    newEmailLabel: "New Email",
    editEmailTitle: "Edit Email",
    editFieldAria: (fieldLabel: string) => `Edit ${fieldLabel}`,
    currentEmailPrefix: "Current email:",
    selectRolePlaceholder: "Select role",
    selectClassroomPlaceholder: "Select classroom",
    deleteStudentErrorDlgTitleStudent: "Error deleting student",
    deleteStudentErrorDlgTitleStaff: "Error deleting staff member",
    deleteStudentErrorDlgMsg:
        "You may only edit the person's info, because there are active or last month orders available.",
    newStudentPlaceholder: "New student",
    newStaffPlaceholder: "New staff member",
    studentInfoHeading: "Student Info",
    staffInfoHeading: "Staff Info",
    personnelSectionHeading: "Personnel Info",
    personnelCheckboxLabel:
        "I work at school and want to order meals through the platform",
    studentsSectionHeading: "Student Info",
    addStudentLink: "Add student",
    staffRoleErrorMsg: "Please select your role in school",
    studentNameLabel: "Student name",
    staffNameLabel: "Staff name",
    studentLastNameLabel: "Student last name",
    staffLastNameLabel: "Staff last name",
    studentClassroomLabel: "Student classroom",
    roleInSchoolLabel: "Role in school:",
    allergiesSectionHeading: "Allergies and other food intolerances",
    allergiesIconAria: "Allergies",
    editPersonRowAria: "Edit",
    deletePersonRowAria: (displayName: string) => `Delete ${displayName}`,
    removePersonnelFromOrderingConfirmTitle: "Remove yourself from school personnel?",
    removePersonnelFromOrderingConfirmMsg: "You won't be able to order staff meals through the platform.",
    removePersonnelFromOrderingConfirmYes: "Remove",
    intolerancesFreeTextLabel: "Other food intolerances",
    intolerancesFreeTextPlaceholder:
        "Food intolerances NOT described above",
    phoneVerifiedBadge: "Phone verified",
    phoneVerificationHeading: "Phone verification",
    phoneSendCode: "Send code",
    phoneEnterCodePrompt: "Enter the code you received:",
    phoneConfirm: "Confirm",
    phoneChangeShort: "Change",
    phoneVerificationNotStarted: "Verification process was not initiated.",
    phoneRecaptchaExpired: "reCAPTCHA expired. Please try again.",
    phoneRecaptchaRenderFailed: "Failed to render reCAPTCHA. Please refresh the page.",
    phoneRecaptchaNotReady: "reCAPTCHA is not ready. Please wait a moment.",
};

const userProfileLangs = { el, en };

export function useUserProfileStrings() {
    const [lang] = useContext(langContext);
    return userProfileLangs[lang];
}
